import styled from 'styled-components';

export const Wrapper = styled.div`
  display: block;
`;

export const ListItem = styled.li`
  list-style-type: none;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  color: #1c1c1c;
`;
